module.exports = __webpack_public_path__ + "assets/images/card-pg-9_44731fb409bce8b66fa5c41ff9092791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/card-pg-9.png
// module id = 196
// module chunks = 0